export default [
  "angrily",
  "suspiciously",
  "serenely",
  "mysteriously",
  "quietly",
  "jovially",
  "slowly",
  "quickly",
  "mischieviously",
  "happily",
  "morosely",
];
